import CountryPageTemplate from './CountryPageTemplate';

export default function SwitzerlandPage() {
  return <CountryPageTemplate countryKey="ch" />;
}